@use '../../styling/typography.scss' as *;
@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;

.TagsInputLabel {
  @extend %form-control-label-font;

  color: $theme-color-text;
  font-weight: $font-weight-semibold;
  margin-bottom: 5px;
}

.TagsInput {
  @extend %form-control-font;
  @extend %form-control-border;

  align-items: center;
  border-top: 0;
  border-bottom: 0;
  font-weight: $font-weight-normal;
  background: $theme-color-form-control-border;

  input {
    border-left: 0;
    border-right: 0;
  }

  >ul {
    margin: 0;
    padding: 8px 12px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    min-height: 60px;
    list-style: none;
    overflow: auto;
    background-color: $theme-dropdown-background-color;
    border-radius: 0px 0px 6px 6px;
    gap: 8px;
    font-weight: 600;
    border-top: 1px solid $theme-color-borders;
    border-bottom: 1px solid $theme-color-form-control-border;

    >li {
      margin: 0px;
    }
  }

  >* {
    margin-top: 0;
    margin-left: 0;
  }
}

.Tooltips {
  padding-left: 1em;
}

.Label {
  display: flex;
  align-items: baseline;
}

.TagsClearAllButton {
  @extend %form-control-font;

  margin-top: -12px; // fieldset gap is 18px, expected gap 6px, so -12px to acheive the space
  display: flex;
  justify-content: end;
}